/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Translation_InfoInputs */

const en_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcribe and translate in one step using Speechmatics.
Translation is only available when the source language is English.`)
};

const fr_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrivez et traduisez en une seule étape avec Speechmatics.
La traduction n’est disponible que lorsque la langue source est l’anglais.`)
};

const de_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Speechmatics können Sie in einem Schritt transkribieren und übersetzen. Die Übersetzung ist nur verfügbar, wenn die Ausgangssprache Englisch ist.`)
};

const it_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrivi e traduci in un unico passaggio con Speechmatics.
La traduzione è disponibile solo se la lingua di partenza è l'inglese.`)
};

const ru_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрибируйте и переводите за один шаг с помощью Speechmatics.
Перевод доступен только в том случае, если исходный язык — английский.`)
};

const es_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcribe y traduce en un solo paso con Speechmatics.
La traducción solo está disponible cuando el idioma de origen es el inglés.`)
};

const zh_cn2_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Speechmatics，一步即可完成转录和翻译。

仅当源语言为英语时，才提供翻译功能。`)
};

const ja_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speechmaticsを使えば、ワンステップで文字起こしと翻訳が可能です。
翻訳は、ソース言語が英語の場合のみ利用可能です。`)
};

const hi_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speechmatics का उपयोग करके एक ही चरण में प्रतिलेखन और अनुवाद करें।
अनुवाद केवल तभी उपलब्ध है जब स्रोत भाषा अंग्रेज़ी हो।`)
};

const pt_pt2_speechmatics_translation_info = /** @type {(inputs: Speechmatics_Translation_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcreva e traduza em uma única etapa usando o Speechmatics.

A tradução só está disponível quando o idioma de origem é o inglês.`)
};

/**
* | output |
* | --- |
* | "Transcribe and translate in one step using Speechmatics. Translation is only available when the source language is English." |
*
* @param {Speechmatics_Translation_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_translation_info = /** @type {((inputs?: Speechmatics_Translation_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Translation_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_translation_info(inputs)
	if (locale === "de") return de_speechmatics_translation_info(inputs)
	if (locale === "it") return it_speechmatics_translation_info(inputs)
	if (locale === "ru") return ru_speechmatics_translation_info(inputs)
	if (locale === "es") return es_speechmatics_translation_info(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_translation_info(inputs)
	if (locale === "ja") return ja_speechmatics_translation_info(inputs)
	if (locale === "hi") return hi_speechmatics_translation_info(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_translation_info(inputs)
	return en_speechmatics_translation_info(inputs)
});